export default "__VITE_ASSET__CLkEqzHl__"